import { StringUtils } from '@shared/util/string-utils';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleUsageVO } from '@article/model/vo/article.vo';
import { ContainerService } from '@3d-scene/model3d/container.service';

export class CaeProjectImportUtils {
  public static readonly WAGO_ARTICLE_NUMBER_PREFIXES: string[] = ['WAGO.', 'WAG.'];

  public static getArticleNumberWithoutWagoPrefix(articleNumber: string): string {
    let result: string = articleNumber;
    for (const prefix of this.WAGO_ARTICLE_NUMBER_PREFIXES) {
      if (StringUtils.startsWith(articleNumber.toLowerCase(), prefix.toLowerCase())) {
        result = articleNumber.substring(prefix.length, articleNumber.length);
        break;
      }
    }
    return result;
  }

  public static hasWagoArticleNumberPrefix(articleNumber: string): boolean {
    for (const prefix of this.WAGO_ARTICLE_NUMBER_PREFIXES) {
      if (StringUtils.startsWith(articleNumber.toLowerCase(), prefix.toLowerCase())) {
        return true;
      }
    }
    return false;
  }

  public static getAllCompositePartUsages(
    compositePartUsage: ArticleUsageVO,
    containerService: ContainerService
  ): ArticleUsageVO[] {
    const compositePartArticle: ArticleContainer = containerService.findArticleContainerInGlobal(compositePartUsage.id);
    return containerService.getCompositePartArticleUsages(compositePartArticle);
  }

  public static isCaeArticleCustomType(caeArticle: { type: string }): boolean {
    if (!caeArticle || !caeArticle.type) {
      return false;
    }
    return caeArticle.type.toLowerCase() === 'custom';
  }
}
